import React, { useEffect, useState } from 'react';

import styles from './index.module.scss';
import LegalLine from '../LegalLine/LegalLine';


let clickCount = 0;
const resetLocalStorage = () => {
  clickCount += 1;
  if (clickCount >= 20) {
    localStorage.clear();
    window.location.reload();
  }
};
interface TemplateProps {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  type?: 'default' | 'error' | 'question';
  legalLine?: 'simple' | 'full';
}

const Template: React.FC<TemplateProps> = ({ title, children, type = 'default', legalLine = 'full' }) => {
  return (
    <div className={`${styles.Template} ${type === 'error' ? styles.error : type === 'question' ? styles.question : ''}`}>
      <div className={styles.TemplateContent}>
        { title && (
          <header>
            <h1>{typeof title === 'string' ? title : title}</h1>
          </header>
        )}
        <div className={styles.TemplateContentInner}>
          {children}
        </div>
        <footer>
          <LegalLine color="black" type={legalLine}/>
        </footer>
      </div>
    </div>
  );
};

export default Template; 